import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    fechaSolicitud: new Date(),
    personalId: 0,
    personal: null,
    personalNombre: null,
    importe: 0,
    observaciones: '',
    rowVersion: null,
    presupuestosInternos: [],

    personalReadOnly: false
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, viaticoId) {
        state.id = viaticoId;

        state.fechaSolicitud = moment(new Date()).format('YYYY-MM-DD');
        state.personalId = 0;
        state.personal = null;
        state.personalNombre = null;
        state.importe = 0;
        state.observaciones = '';
        state.rowVersion = null;
        state.presupuestosInternos = [];

        state.personalReadOnly = false;
    },
    'SET_VIATICO' (state, viatico) {
        state.fechaSolicitud = moment(viatico.fechaSolicitud).format('YYYY-MM-DD');
        state.personalId = viatico.personal? viatico.personal.id : 0;
        state.personal = viatico.personal;
        state.personalNombre = viatico.personal? viatico.personal.nombre.trim() : null;
        state.importe = viatico.importe;
        state.observaciones = viatico.observaciones;
        state.rowVersion = viatico.rowVersion;
        
        if (viatico.viaticoPresupuestosInternos) {
            if (viatico.viaticoPresupuestosInternos.length != 0) {
                state.presupuestosInternos = viatico.viaticoPresupuestosInternos.map(viaticoPresupuestoInterno => ({
                    presupuestoInternoId: viaticoPresupuestoInterno.presupuestoInternoId,
                    presupuestoInternoNumero: viaticoPresupuestoInterno.presupuestoNumero.trim(),
                    presupuestoInterno: viaticoPresupuestoInterno.presupuestoInterno.trim(),
                    ordenTrabajoId: viaticoPresupuestoInterno.ordenTrabajoId,
                    ordenTrabajo: viaticoPresupuestoInterno.ordenTrabajo.trim(), 
                    importe: parseFloat(viaticoPresupuestoInterno.importe)
                }));
            }
        }
    },
    'SET_PERSONAL'(state, personal) {
        state.personal = personal;
        if (personal) {
            state.personalId = personal.id? personal.id : 0;
            state.personalNombre = personal.nombre? personal.nombre.trim() : null;
        } else {
            state.personalId = 0;
            state.personalNombre = null;
        }
    },
    'ADD_PRESUPUESTO'(state, params) {
        state.presupuestosInternos.push({
            presupuestoInternoId: params.presupuestoInterno.id,
            presupuestoInternoNumero: params.presupuestoInterno.presupuestoNumero,
            presupuestoInterno: params.presupuestoInterno.nombre.trim(),
            ordenTrabajoId: params.ordenTrabajo.id,
            ordenTrabajo: `(${params.ordenTrabajo.id}) ${params.ordenTrabajo.rubroTrabajo.trim()}`,
            importe: 0
        });
    },
    'REMOVE_PRESUPUESTO'(state, presupuestoInternoId) {
        let itemKey = state.presupuestosInternos
            .findIndex(t => t.presupuestoInternoId == presupuestoInternoId);

        if (itemKey != -1) {
            state.presupuestosInternos.splice(itemKey, 1);
        }        
    },
};

const actions = {
    inicializar ( { commit }, viaticoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', viaticoId);
            
            let url = 'viaticos/add';
            if (viaticoId != 0) {
                url = 'viaticos/' + viaticoId + '/edit'
            }

            apiAxios.get(url)
                .then(res => {
                    commit('SET_VIATICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let viaticoPresupuestosInternos;

            if (state.presupuestosInternos) {
                if (state.presupuestosInternos.length != 0) {
                    viaticoPresupuestosInternos = state.presupuestosInternos.map(presupuestoInterno => ({
                        presupuestoInternoId: presupuestoInterno.presupuestoInternoId,
                        ordenTrabajoId: presupuestoInterno.ordenTrabajoId,
                        importe: presupuestoInterno.importe
                    }))
                }
            }

            let viatico= {
                fechaSolicitud: moment(state.fechaSolicitud).format('YYYY-MM-DD'),
                personalId: state.personalId,
                importe: state.importe,
                observaciones: state.observaciones,
                viaticoPresupuestosInternos
            };

            let url = 'viaticos';
            if (state.id != 0) {
                url += '/' + state.id;
                viatico.rowVersion = state.rowVersion;
            }
            apiAxios.post(url, viatico)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setPersonal: ({commit}, personal) => {
        commit('SET_PERSONAL', personal);
    },
    addPresupuesto: ({commit}, params) => {
        commit('ADD_PRESUPUESTO', params);
    },
    removePresupuesto: ({commit}, presupuestoInternoId) => {
        commit('REMOVE_PRESUPUESTO', presupuestoInternoId);
    },
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}